import { Grid, Button, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import resultImage from "../assets/logo/Group 37659.png";

function SignUpResult() {
  const navigate = useNavigate();
  const handleClick = () => {
    window.sessionStorage.removeItem("action-type");
    window.sessionStorage.removeItem("phoneNumber");
    window.sessionStorage.removeItem("email");
    navigate("sign-in");
  };

  return (
    <Grid
      container
      maxWidth="1920px"
      width="100%"
      minHeight="100vh"
      bgcolor={{ xs: "#fff", sm: "#FAFAFA", md: "#FAFAFA" }}
      display="flex"
      flexDirection="column"
      justifyContent={"space-between"}
      alignItems="center"
      fontFamily="VazirMedium"
      position="relative"
    >
      <Box
        container
        xs={4}
        bgcolor="#fff"
        borderRadius={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        mt="10vh"
        sx={{ boxSizing: "border-box" }}
        py={{ xs: 2, sm: 5, md: 4 }}
        px={{ xs: 2, sm: 4, md: 6 }}
      >
        <Logo1 style={{ marginBottom: "5rem" }} />
        <img src={resultImage} alt="success" />
        <Typography variant="h1" mt={"1rem"}>
          ثبت نام با موفقیت انجام شد
        </Typography>
        <Button variant="l" sx={{ mt: 6 }} onClick={handleClick}>
          ورود
        </Button>
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row-reverse", md: "row-reverse" }}
        width="100%"
        justifyContent="space-between"
        alignItems="center"
      >
        <Button variant="s2" sx={{ backgroundColor: "transparent", whiteSpace: "nowrap" }}>
          ورود مدیران و مراکز
        </Button>
        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent={{ xs: "space-between", sm: "flex-start", md: "flex-start" }}
          width="100%"
        >
          <Button variant="s2" sx={{ backgroundColor: "transparent" }}>
            تماس با ما
          </Button>
          <Button variant="s2" sx={{ backgroundColor: "transparent" }}>
            درباره هدا
          </Button>
        </Box>
      </Box>
    </Grid>
  );
}

export default SignUpResult;
